export default __webpack_public_path__ + "static/gender_male-9cc48b991a26dcdc771a98b3764e3d88.png";